/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const USERS_BASE_LINK = '/admin/users'

export function getUserCreateLink () {
  return `${USERS_BASE_LINK}/create`
}

export function getUserLink (id: number) {
  return `${USERS_BASE_LINK}/${id}/edit`
}

export function getUserListLink () {
  return USERS_BASE_LINK
}
